module.exports = __webpack_public_path__ + "img/statistics.232be99b.png";